import { en } from './en.js'

export const ja = structuredClone(en)
